import React from 'react';
import styled from 'styled-components';
import Title from './title';

export default styled(({ className }) => (<Title className={className}>Volg mij</Title>))`
  font-family: ${(props) => props.theme.standoutFontFamily};
  text-transform: uppercase;
`;
